import XhrTool from "./tool/xhr";
import browserHelper from "./tool/browserHelper";
import { v4 as uuid } from "uuid";
import { LogEnv, _logLevel, HOST } from "./config";
import { connectivity } from "./tool/connectivity";
import { toStringify } from "./tool/toStringify";

let os = browserHelper.getOS();
let browser = browserHelper.getBrowser();
let ua = browserHelper.getUA();
let resolution = browserHelper.getResolution();
const initialBaseInfo = {
  APIVersion: "0.6.0",
  app: "xhxzb",
  app_version: "1.0.0",
  client_type: "web",
  os: os,
  browser: browser.browser + " " + browser.ver,
  user_agent: ua,
  resolution: resolution,
  device_id: getDeviceId(),
};

/**
 * 获取设备Id
 */
function getDeviceId() {
  try {
    let deviceId = window.localStorage.getItem("device_id");
    if (!deviceId) {
      deviceId = uuid();
      window.localStorage.setItem("device_id", deviceId);
    }
    return deviceId;
  } catch (e) {
    return "";
  }
}

/**
 * 格式化用户数据
 * @param {object} param
 */
function formatParam(param) {
  param = serializeErrors(param);
  if (Object.prototype.toString.call(param) !== "[object Object]") {
    return {
      content: param,
    };
  } else {
    for (let key in param) {
      if (Object.prototype.toString.call(param[key]) === "[object Object]") {
        param[key] = toStringify(param, key);
      }
    }
  }
  return param;
}
/**
 * 遍历 序列化Error对象
 * @param {*} obj
 * @returns
 */
function serializeErrors(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  // 处理 Error 对象
  if (obj instanceof Error) {
    const serialized = {
      name: obj.name,
      message: obj.message,
      stack: obj.stack,
    };
    if (obj.cause) {
      serialized.cause = serializeErrors(obj.cause);
    }
    // 保留其他可能存在的自定义错误属性
    for (const key in obj) {
      if (
        key !== "name" &&
        key !== "message" &&
        key !== "cause" &&
        Object.prototype.hasOwnProperty.call(obj, key)
      ) {
        serialized[key] = serializeErrors(obj[key]);
      }
    }
    return serialized;
  }

  // 处理数组
  if (Array.isArray(obj)) {
    return obj.map((item) => serializeErrors(item));
  }

  // 处理普通对象
  const result = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = serializeErrors(obj[key]);
    }
  }
  return result;
}

/**
 * 开课啦阿里云日志sdk
 * @description 注意，若没有调用 setLogEnv 来指定日志环境，则日志默认上传置开发环境仓库，即 xhx-front-dev
 */
class KKLLOG {
  /**
   *
   * @param {object} baseInfo 客户端类型：ios、android、web 等，默认 web
   */
  static addBaseInfo(baseInfo) {
    try {
      if (typeof baseInfo.phone !== "undefined") {
        baseInfo.phone = baseInfo.phone
          .toString()
          .replace(/^(.{3}).{4}/, "$1****");
      }
    } catch (error) {
      console.warn(error.message);
    }

    Object.assign(initialBaseInfo, baseInfo);
  }

  /**
   *
   * @param {LogProject} logProject 新航线日志项目名
   * @param {LogStrore} LogStrore 开课啦日志仓库
   * @param {logTopic} logTopic 开课啦日志 Topic
   * @param {string} env 目标环境
   * @param {string} protocol 指定protocol。 ex：https: or http:
   * @param {number} batchCount 批量上传数量
   */
  constructor(logProject, logStrore, logTopic, logEnv, protocol, batchCount) {
    (this._logProject = logProject),
      (this._logStrore = logStrore),
      (this._logEnv = logEnv),
      (this.baseInfo = Object.assign({}, initialBaseInfo));
    this.xhrTool = new XhrTool(logTopic, batchCount);
    this.xhrTool.createAxiosInstance();
    !protocol && (protocol = "");
    this.logUrl = this._buildLogUrl(protocol);
    if (this._logEnv === LogEnv.prod) {
      this.backupUrl = `https://kkl-log.estudy.cn/${logProject}/logstores/${logStrore}/track`;
    }
  }

  addBaseInfo(baseInfo) {
    try {
      if (typeof baseInfo.phone !== "undefined") {
        baseInfo.phone = baseInfo.phone
          .toString()
          .replace(/^(.{3}).{4}/, "$1****");
      }
    } catch (error) {
      console.warn(error.message);
    }

    this.baseInfo = Object.assign({}, this.baseInfo, baseInfo);
  }
  /**
   * 组装日志上传地址
   */
  _buildLogUrl(protocol) {
    // 如果是线上环境，仓库名不带后缀
    // 如果是sit环境，带sit后缀
    // 如果是dev环境，带dev后缀
    // 如果没配置环境，则默认为dev环境
    var logStrore = this._logStrore;
    if (this._logEnv === LogEnv.prod) {
    } else if (this._logEnv === LogEnv.sit) {
      logStrore = logStrore + "-sit";
    } else {
      logStrore = logStrore + "-dev";
    }
    return `${protocol}//${this._logProject}.${HOST}/logstores/${logStrore}/track`;
  }

  _log(moduleName, logLevel, logParam) {
    // 如果没有logParam参数，则表示改方法没有模块名，或者模块定义在只上传数据
    if (typeof logParam === "undefined") {
      logParam = moduleName;
      moduleName = moduleName || "";
    }

    let formatLogparam = formatParam(logParam);
    let timeNow = new Date();
    let timeFormat = "";
    try {
      timeFormat =
        "" +
        timeNow.getFullYear() +
        "/" +
        (timeNow.getMonth() + 1) +
        "/" +
        timeNow.getDate() +
        " " +
        timeNow.getHours() +
        ":" +
        timeNow.getMinutes() +
        ":" +
        timeNow.getSeconds();
    } catch (error) {}

    let logFullInfo = Object.assign(
      {},
      initialBaseInfo,
      this.baseInfo,
      formatLogparam,
      {
        module: moduleName,
        level: logLevel,
        timestamp: timeNow.getTime(),
        time_format: timeFormat,
      }
    );
    this.xhrTool.send(this.logUrl, logFullInfo, this.backupUrl);
  }

  /**
   * 修改日志环境
   * @param {LogEnv} logEnv 目标环境
   */
  changeEnv(logEnv) {
    this._logEnv = logEnv;
    this.logUrl = this._buildLogUrl();
  }

  /**
   * 跟踪调试
   * @param {string} moduleName 模块名称
   * @param {object} logParam 日志信息对象 注意：logParam 必须包含content字段, sub_module 为可选字段，也可添加其他扩展字段
   * @description 用于追踪程序运行轨迹，方便排查问题
   */
  trace(moduleName, logParam) {
    this._log(moduleName, _logLevel.trace, logParam);
  }

  /**
   * 开发调试日志
   * @param {string} moduleName 模块名称
   * @param {object} logParam 日志信息对象 注意：logParam 必须包含content字段, sub_module 为可选字段，也可添加其他扩展字段
   * @description 指出细粒度信息事件对调试应用程序是非常有帮助的
   */
  debug(moduleName, logParam) {
    this._log(moduleName, _logLevel.debug, logParam);
  }

  /**
   * 普通信息
   * @param {string} moduleName 模块名称
   * @param {object} logParam 日志信息对象 注意：logParam 必须包含content字段, sub_module 为可选字段，也可添加其他扩展字段
   * @description 消息在粗粒度级别上突出强调应用程序的运行过程
   */
  info(moduleName, logParam) {
    this._log(moduleName, _logLevel.info, logParam);
  }

  /**
   * 警告
   * @param {string} moduleName 模块名称
   * @param {object} logParam 日志信息对象 注意：logParam 必须包含content字段, sub_module 为可选字段，也可添加其他扩展字段
   * @description 表明会出现潜在错误的情形
   */
  warn(moduleName, logParam) {
    this._log(moduleName, _logLevel.warn, logParam);
  }

  /**
   * 错误
   * @param {string} moduleName 模块名称
   * @param {object} logParam 日志信息对象 注意：logParam 必须包含content字段, sub_module 为可选字段，也可添加其他扩展字段
   * @description 虽然发生错误事件，但仍然不影响系统的继续运行
   */
  error(moduleName, logParam) {
    this._log(moduleName, _logLevel.error, logParam);
  }

  /**
   * 致命
   * @param {string} moduleName 模块名称
   * @param {object} logParam 日志信息对象 注意：logParam 必须包含content字段, sub_module 为可选字段，也可添加其他扩展字段
   * @description 致命的错误事件将会导致应用程序的退出
   */
  fatal(moduleName, logParam) {
    this._log(moduleName, _logLevel.fatal, logParam);
  }

  /**
   * 监控
   * @param {object} logParam 日志信息对象
   */

  /**
   * 监控
   * @param {object} logParam 日志信息对象
   * @param {boolean} needDeviceInfo 是否需要附加设备信息
   */
  monitor(logParam, needDeviceInfo = false) {
    let formatLogparam = formatParam(logParam);
    let timeNow = new Date();
    let timeFormat = "";
    try {
      timeFormat =
        "" +
        timeNow.getFullYear() +
        "/" +
        (timeNow.getMonth() + 1) +
        "/" +
        timeNow.getDate() +
        " " +
        timeNow.getHours() +
        ":" +
        timeNow.getMinutes() +
        ":" +
        timeNow.getSeconds();
    } catch (error) {}

    const {member_id,device_id,os} = initialBaseInfo;
    let logFullInfo = Object.assign({}, formatLogparam, {
      timestamp: timeNow.getTime(),
      event_time: timeFormat,
      member_id,
      device_id,
      os,
      log_uuid: uuid(),
      client_type: "web",
    });
    if (needDeviceInfo) {
      logFullInfo.device_info = initialBaseInfo;
    }
    this.xhrTool.send(this.logUrl, logFullInfo, this.backupUrl);
  }

  /**
   * @description: 上传通道连通性测试
   * @return {Promise<Array<Boolean>>}
   */
  connectivity() {
    const urlList = [
      {
        url: this.logUrl,
        param: {
          __topic__: "connectivity",
          __logs__: [{ APIVersion: "0.6.0" }],
          __tags__: {},
        },
      },
    ];
    this.backupUrl &&
      urlList.push({
        url: this.backupUrl,
        param: {
          __topic__: "connectivity",
          __logs__: [{ APIVersion: "0.6.0" }],
          __tags__: {
            channal: "kkl_proxy",
          },
        },
      });
    return connectivity(urlList);
  }
}

export default KKLLOG;
